<div
    *ngIf="staticMode; else swiperMode"
    class="w-100 d-flex justify-content-center align-items-center static-nav"
>
    <div
        class="static-nav-item radius-tertiary center position-relative"
        [class.active]="isActive(item)"
        [class.disabled]="isItemDisabled(item)"
        *ngFor="let item of visibleItems"
        (click)="selectStaticItem(item)"
        [style.pointer-events]="isItemDisabled(item) ? 'none' : 'auto'"
    >
        <div class="position-relative d-inline-block">
            <img
                src="/assets/svg/{{ item.icon }}.svg"
                height="20px"
                class="{{ item.icon }}"
            />
            <span
                *ngIf="isItemDisabled(item)"
                class="position-absolute"
                style="font-size: 9px; top: -12px; right: -14px"
                >🔒</span
            >
        </div>
    </div>
</div>

<ng-template #swiperMode>
    <div #swiper class="w-100 justify-content-between fadeInFast">
        <div class="swiper-wrapper">
            <div
                class="swiper-slide radius-tertiary center"
                *ngFor="let item of visibleItems"
            >
                <img
                    src="/assets/svg/{{ item.icon }}.svg"
                    height="20px"
                    class="{{ item.icon }}"
                />
            </div>
        </div>
    </div>
</ng-template>
